export type PasswordChecks = {
  hasLength: boolean
  hasUpperCase: boolean
  hasLowerCase: boolean
  hasNumber: boolean
}

export type PasswordRule = {
  key: keyof PasswordChecks
  label: string
}

export const PASSWORD_RULES: PasswordRule[] = [
  { key: 'hasLength', label: '8-аас дээш тэмдэгттэй' },
  { key: 'hasUpperCase', label: 'Том үсэг орсон байх' },
  { key: 'hasLowerCase', label: 'Жижиг үсэг орсон байх' },
  { key: 'hasNumber', label: 'Тоо орсон байх' },
]

export function validatePassword(password: string): PasswordChecks {
  return {
    hasLength: password.length >= 8,
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
  }
}

export function getPasswordError(password: string, confirm: string): string | null {
  if (!password || !confirm) return 'Шинэ нууц үгээ оруулна уу'
  if (password !== confirm) return 'Шинэ нууц үг таарахгүй байна'
  const checks = validatePassword(password)
  if (!checks.hasLength) return 'Нууц үг 8-аас дээш тэмдэгттэй байх ёстой'
  if (!checks.hasUpperCase) return 'Нууц үгэнд том үсэг орсон байх ёстой'
  if (!checks.hasLowerCase) return 'Нууц үгэнд жижиг үсэг орсон байх ёстой'
  if (!checks.hasNumber) return 'Нууц үгэнд тоо орсон байх ёстой'
  return null
}
